import * as React from 'react';
import { UitkIcon } from 'uitk-react-icons';
import { Link } from 'react-router-dom';
import { ClickTracker } from 'bernie-analytics';
const LinkTracked = ClickTracker(Link);

export interface HoldingAreaHeaderProps {
  numberOfItems: number;
  linkTo: {
    pathname: string;
    search: string;
  };
  setToggleRef: (ref) => void;
  titleText: string;
}

export const HoldingAreaHeader = ({ numberOfItems, linkTo, setToggleRef, titleText }: HoldingAreaHeaderProps) => {
  if (numberOfItems <= 0) {
    return null;
  }

  return (
    <LinkTracked
      linkName="Expand Holding Area"
      rfrr="MultiProp.Expand"
      to={linkTo}
      innerRef={setToggleRef}
      className="uitk-grid uitk-cell all-cell-1-1"
    >
      <div className="uitk-cell all-cell-shrink all-cell-align-start">
        <span data-stid="holding-area__header-text" className="all-x-margin-two">
          {titleText}
        </span>
      </div>
      <div className="uitk-cell all-cell-shrink all-cell-align-end">
        <UitkIcon name="expand_less" />
      </div>
    </LinkTracked>
  );
};
